import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

const Echocardiography = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'clinicalstudy.echocardiography'} />}
      newButton={
        <DocumentCreationButton
          name="echocardiography"
          text={'clinicalstudy.newEchocardiography'}
          onClick={startEdit({}, 'echocardiography')}
          width={15}
          height={3}
          fontSize={12}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'clinicalstudy.result'} />
            </Item>
            <Item xs={6}>
              <FormattedMessage id={'clinicalstudy.additionalInformation'} />
            </Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {formatPartialDate(d.date)}
            </Item>
            <Item xs={2}>
              {d.result ? <FormattedMessage id={`clinicalstudy.opts.normalBorderlineAbnormal.${d.result}`} /> : '-'}
            </Item>
            <Item xs={3}>
              <div style={{ marginRight: '3rem', wordBreak: 'break-word' }}>{d.additionalInformation ?? '-'}</div>
            </Item>
            <Item xs={2}>&nbsp;</Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'echocardiography'>[];
  startEdit: StartEdit;
}

export default Echocardiography;
